import React from 'react'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { LabelingContainer } from '~/components/elements/LabelingContainer'
import {
  StyledInput,
  type StyledInputProps,
} from '~/components/elements/StyledInput'
import { useFormField } from '~/hooks/useFormField'
import { useLogEvent } from '~/hooks/useLogEvent'

import { type InputValues } from '../utils'

export const TitleInput = () => {
  const { control } = useFormContext<InputValues>()
  const titleField = useFormField(control, 'title')
  const { t } = useTranslation()

  const logEvent = useLogEvent()
  const handleBlur = React.useCallback<EH<StyledInputProps, 'onBlur'>>(() => {
    titleField.onBlur()
    logEvent('Edit title', { withSuffix: true })
  }, [logEvent, titleField])

  return (
    <LabelingContainer label={t('name_5')}>
      <StyledInput width="100%" {...titleField} onBlur={handleBlur} />
    </LabelingContainer>
  )
}
